import { Schema } from 'effect';
import { payoutDetailsViewParam } from '~/pages/dashboard/admin/payouts/payoutDetailsV2View';

export const BetaPageId = Schema.Literals(['users', 'accounts', 'payoutDetails']);
export type BetaPageId = typeof BetaPageId.Type;

export const betaPages: Record<
  BetaPageId,
  {
    readonly name: string;
    readonly switching:
      | { readonly kind: 'route'; readonly classicPath: string; readonly betaPath: string }
      | { readonly kind: 'in-place'; readonly viewParam: string };
  }
> = {
  users: {
    name: 'Users',
    switching: {
      kind: 'route',
      classicPath: '/dashboard/admin/users',
      betaPath: '/dashboard/admin/users-v2',
    },
  },
  accounts: {
    name: 'Accounts',
    switching: {
      kind: 'route',
      classicPath: '/dashboard/admin/accounts',
      betaPath: '/dashboard/admin/accounts-v2',
    },
  },
  payoutDetails: {
    name: 'Payout details',
    switching: { kind: 'in-place', viewParam: payoutDetailsViewParam },
  },
};
